import { render, staticRenderFns } from "./DoctorsUtilityDataTable.vue?vue&type=template&id=3bd71e9a&scoped=true"
import script from "./DoctorsUtilityDataTable.vue?vue&type=script&lang=js"
export * from "./DoctorsUtilityDataTable.vue?vue&type=script&lang=js"
import style0 from "./DoctorsUtilityDataTable.vue?vue&type=style&index=0&id=3bd71e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd71e9a",
  null
  
)

export default component.exports